import React from 'react'

const CansMocktailsTemplate = (props) => {
    console.log(props)
    const canBeer = props.cansMenu
    const mocktails = props.mocktailsMenu

    const getPrice = (number) => {
        let price = parseFloat(number)
        return price
    }

    return (
        <div>
            <div className="cans-mocktails-page">
                <div className="background-image">
                    <div className="col-left">
                        <div className="column pl1-taps-cans-pg-left ">
                            <div className="pl1-cans-new">
                            {canBeer ? 
                                <>
                                     {canBeer.map(item => (
                                        <div className="pl-can-item-page tap-item-print">
                                            {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                            <div className="print-item-line-two pl1">{item.containers[0].name} • <span className="style-print-can pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                                        </div>
                                    ))}
                                </>
                                :
                                <>loading...</>
                            }
                            </div>
                        </div>
                    </div>
                    <div className="col-right">
                        <div className="column pl1-cans-mocktails-pg-right">
                            <div className="cocktail-container cocktail-mocktail-container-new">
                                {mocktails
                                    ?
                                    <div>
                                        <div className="cocktail-section">
                                            <div className="cocktail-section-title">
                                                Mocktails
                                            </div>
                                            {mocktails.map(cocktail =>(
                                                <div className="cocktail-item cocktail-item-new">
                                                    <div className="cocktail-item-title">{cocktail.name} • <span className="cocktail-price">{getPrice(cocktail.containers[0].price)}</span></div>
                                                    <div className="cocktail-item-description">{cocktail.description}</div>
                                                </div>
                                            ))}

                                        </div>
                                       
                                    </div>
                                    :
                                    <div>loading...</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CansMocktailsTemplate